<div
	[ngClass]="{
		'md:justify-between': total() > 0,
		'md:justify-end': total() === 0,
	}"
	class="flex flex-col w-full mb-6 -mt-12 md:mt-0 md:flex-row md:items-center"
>
	@if (total() > 0) {
		<p class="order-2 pt-5 text-xl font-bold md:pt-0 md:order-1">
			{{ total() | number: '' : 'en-GB' }}
			{{ text() }}
		</p>
	}

	<div
		class="flex items-center justify-between order-1 gap-4 pt-5 bg-white md:py-0 md:order-2 md:border-b-0"
		[ngClass]="{ 'border-b py-5': total() > 0 }"
	>
		@if (studyLevel()) {
			<div
				class="inline-flex items-center p-3 text-sm font-bold border border-gray-300 rounded-full md:hidden whitespace-nowrap"
			>
				<span class="capitalize">Study Level: {{ studyLevel() }}</span>
			</div>
		}
		<uc-show-filter-button
			class="order-2 md:order-1 lg:hidden"
			[length]="totalPills()"
			(toggleFilter)="toggleFilter.emit(true)"
		/>
		@if (sortOptions(); as sortOptions) {
			<uc-sort-v1
				class="order-1 md:order-2"
				[showSelectOnDesktop]="true"
				[options]="sortOptions"
				[defaultSelectedOption]="selectedSortOption()"
				(sort)="sort.emit($event)"
			/>
		}
	</div>
</div>
